import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  STATIC_TEXT_REPOSITORY,
  StaticTextRepository
} from '@app/domain/repositories/static-text/static-text.repository.contract';
import { StaticText } from '@app/entities/models/static-text/static-text.model';

import { StaticTextUseCases } from './static-text.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class StaticTextUseCasesImpl implements StaticTextUseCases {
  #staticTextRepository: StaticTextRepository = inject(STATIC_TEXT_REPOSITORY);

  getStaticText(key: string, lang?: string): Observable<StaticText> {
    return this.#staticTextRepository.getStaticText(key, lang);
  }
}
